import {useNavigate} from 'react-router-dom';
import {useAuth} from '@features/auth';
import {Box, ButtonBase, IconButton, Stack, Typography} from '@mui/material';

import {ROUTE__CURRENT_USER_PROFILE} from '@shared/constants';
import {useTimezone} from '@shared/hooks';
import {UserAvatarDoubleBordered} from '../UserAvatarDoubleBordered';

export const UserProfileButton = () => {
  const navigate = useNavigate();
  const {currentUser} = useAuth();
  const {name, avatar} = currentUser!;
  const {timezone} = useTimezone();

  const handleClick = () => {
    navigate(ROUTE__CURRENT_USER_PROFILE);
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <IconButton size="small" onClick={handleClick}>
        <UserAvatarDoubleBordered name={name} photoUrl={avatar} size={48} />
      </IconButton>

      <ButtonBase onClick={handleClick}>
        <Stack alignItems="flex-start">
          <Typography>{name}</Typography>
          <Typography variant="b5regular" sx={{color: 'text.secondary'}}>
            TZ: {timezone}
          </Typography>
        </Stack>
      </ButtonBase>
    </Box>
  );
};
